import { BankerConstant, BankerRequiredFieldList } from "presentation/constant/Banker/BankerConstant";
import { useBankerVM } from "presentation/hook/Banker/useBankerVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBankerTracked } from "presentation/store/Banker/BankerProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const BankerEditPanel = () => {
    const SCREEN_CONSTANT = BankerConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [bankerState] = useBankerTracked();
    const bankerVM = useBankerVM();
    const { currentEditRow, isAdd, isEdit, masterState } = bankerState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const handleSave = useCallback(async () => {
        // if (!currentEditRow.bankCode) {
        //     messageBarVM.showError("Bank Code is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.bankName?.trim()) {
        //     messageBarVM.showError("Bank Name is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.bankAcNo?.trim()) {
        //     messageBarVM.showError("Bank A/C No. is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.bankAcCurrency?.trim()) {
        //     messageBarVM.showError("Bank A/C Currency is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.bankAddressLine1?.trim()) {
        //     messageBarVM.showError("Bank Address Line 1 is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        // if (currentEditRow.bankAcNo && currentEditRow.bankAcNo.length !== 24) {
        //     messageBarVM.showError("BANK A/C No.should be 24 digits.");
        //     return;
        // }
        setIsLoading(true);
        bankerVM.onSaveClicked();
        await bankerVM.onSave(currentEditRow).then(data => {
            if (data && data.success) {
                bankerVM.onSearch().then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            } else {
                setIsLoading(false)
                data.data && messageBarVM.showError(data.data);
                return;
            }
        });
    }, [currentEditRow, messageBarVM, bankerVM]);

    const handClose = useCallback(() => {
        bankerVM.onCloseEidtPanel();
    }, [bankerVM]);

    const memoCreatedDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "230px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.CREATED_DATE}
                width="230px"
                date={currentEditRow?.createdDateTime}
                fieldName="createdDateTime"
                errorMessage={''}
                onDateChange={bankerVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.CREATED_DATE, currentEditRow?.createdDateTime, bankerVM.onFieldChange])

    const memoLastUpdatedDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "230px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.LAST_UPDATED_DATE}
                width="230px"
                date={currentEditRow?.updatedDateTime}
                fieldName="lastUpdatedDate"
                errorMessage={''}
                onDateChange={bankerVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.LAST_UPDATED_DATE, currentEditRow?.updatedDateTime, bankerVM.onFieldChange])


    const memoBankerCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.bankCode ?? ""}
                fieldValue={currentEditRow?.bankCode ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankCode'}
                maxLength={50}
                isMultipleDropDown={true}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, currentEditRow.bankCode, SCREEN_CONSTANT.BANK_CODE, isSaveClicked, bankerVM])

    const memoBankerName = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.bankName ?? ""}
                fieldValue={currentEditRow?.bankName ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_NAME}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankName'}
                maxLength={150}
                isMultipleDropDown={true}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankName, SCREEN_CONSTANT.BANK_NAME, isSaveClicked, bankerVM])

    const memoBankACNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.bankAcNo ?? ""}
                fieldValue={currentEditRow?.bankAcNo ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_AC_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankAcNo'}
                maxLength={24}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankAcNo, SCREEN_CONSTANT.BANK_AC_NO, isSaveClicked, bankerVM])

    const memoBankACCurrency = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.bankAcCurrency ?? ''}
                fieldValue={currentEditRow?.bankAcCurrency}
                fieldLabel={SCREEN_CONSTANT.BANK_AC_CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'bankAcCurrency'}
                maxLength={3}
                options={bankerState.dynamicOptions.currencyCodeDropdownOptions}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />

        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.bankAcCurrency, SCREEN_CONSTANT.BANK_AC_CURRENCY, isSaveClicked, bankerState.dynamicOptions.currencyCodeDropdownOptions, bankerVM])

    const memoBankContactPerson = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.bankContactPerson ?? ""}
                fieldValue={currentEditRow?.bankContactPerson ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_CONTACT_PERSON}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankContactPerson'}
                maxLength={30}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankContactPerson, SCREEN_CONSTANT.BANK_CONTACT_PERSON, isSaveClicked, bankerVM])

    const memoContactNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.contactNo ?? ""}
                fieldValue={currentEditRow?.contactNo ?? ""}
                fieldLabel={SCREEN_CONSTANT.CONTACT_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'contactNo'}
                maxLength={15}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.contactNo, SCREEN_CONSTANT.CONTACT_NO, isSaveClicked, bankerVM])

    const memoBankAddressLine1 = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1010px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.bankAddressLine1 ?? ""}
                fieldValue={currentEditRow?.bankAddressLine1 ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_ADDRESS_LINE_1}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankAddressLine1'}
                maxLength={150}
                isMultipleDropDown={true}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankAddressLine1, SCREEN_CONSTANT.BANK_ADDRESS_LINE_1, isSaveClicked, bankerVM])

    const memoBankAddressLine2 = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1010px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.bankAddressLine2 ?? ""}
                fieldValue={currentEditRow?.bankAddressLine2 ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_ADDRESS_LINE_2}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankAddressLine2'}
                maxLength={150}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankAddressLine2, SCREEN_CONSTANT.BANK_ADDRESS_LINE_2, isSaveClicked, bankerVM])

    const memoBankAddressLine3 = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1010px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.bankAddressLine3 ?? ""}
                fieldValue={currentEditRow?.bankAddressLine3 ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_ADDRESS_LINE_3}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankAddressLine3'}
                maxLength={150}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankAddressLine3, SCREEN_CONSTANT.BANK_ADDRESS_LINE_3, isSaveClicked, bankerVM])

    const memoBankAddressLine4 = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1010px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.bankAddressLine4 ?? ""}
                fieldValue={currentEditRow?.bankAddressLine4 ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_ADDRESS_LINE_4}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankAddressLine4'}
                maxLength={150}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankAddressLine4, SCREEN_CONSTANT.BANK_ADDRESS_LINE_4, isSaveClicked, bankerVM])

    const memoBankAddressLine5 = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1010px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow.bankAddressLine5 ?? ""}
                fieldValue={currentEditRow?.bankAddressLine5 ?? ""}
                fieldLabel={SCREEN_CONSTANT.BANK_ADDRESS_LINE_5}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'bankAddressLine5'}
                maxLength={150}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.bankAddressLine5, SCREEN_CONSTANT.BANK_ADDRESS_LINE_5, isSaveClicked, bankerVM])

    const memoCreatedBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "230px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEditRow.createdBy ?? ""}
                fieldValue={currentEditRow?.createdBy ?? ""}
                fieldLabel={SCREEN_CONSTANT.CREATED_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'createdBy'}
                maxLength={30}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentEditRow.createdBy, SCREEN_CONSTANT.CREATED_BY, isSaveClicked, bankerVM])

    const memoUpdatedBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "230px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEditRow.updatedBy ?? ""}
                fieldValue={currentEditRow?.updatedBy ?? ""}
                fieldLabel={SCREEN_CONSTANT.LAST_UPDATED_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'updatedBy'}
                maxLength={30}
                requiredFieldList={BankerRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    bankerVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentEditRow.updatedBy, SCREEN_CONSTANT.LAST_UPDATED_BY, isSaveClicked, bankerVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "490px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={BankerRequiredFieldList}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => bankerVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEditRow?.activeInd, isAdd, isEdit, bankerVM])

    const handleEdit = useCallback(() => {
        bankerVM.onEditClick();
    }, [bankerVM]);

    const handleReset = useCallback(() => {
        bankerVM.onResetClick(isAdd);
    }, [bankerVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: SCREEN_CONSTANT.CATEGORY },
                    { title: SCREEN_CONSTANT.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Banker"}
                                    {!isAdd && currentEditRow.bankCode}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>

                        <CriteriaItemContainer>
                            {memoBankerCode}
                            {memoBankerName}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankACNo}
                            {memoBankACCurrency}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankContactPerson}
                            {memoContactNo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankAddressLine1}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankAddressLine2}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankAddressLine3}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankAddressLine4}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoBankAddressLine5}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoCreatedBy}
                            {memoCreatedDate}
                            {memoUpdatedBy}
                            {memoLastUpdatedDate}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoActiveInd}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default BankerEditPanel;
